var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-content',[_c('app-content-head',{attrs:{"title":"Profile","subtitle":"Manage your profile and preferences."}}),_c('app-content-body',{staticClass:"profile"},[_c('div',{staticClass:"profile-main"},[_c('com-profile'),_c('com-account'),_c('com-password')],1),_c('div',{staticClass:"profile-side"},[_c('com-settings')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }